<template>
  <div>
    <div v-show="!editMode">
      <el-tree slot="sideContent" ref="jobGrpTree" :data="jobGrpTreeData" :props="defaultProps" :node-key="defaultProps.treeKey" :expand-on-click-node="false" highlight-current default-expand-all
      @current-change="onCurrentGroupNodeChange" @node-click="onGroupNodeClick">
      </el-tree>
    </div>
    <!-- 트리 편집 -->
    <div v-show="editMode">
      <el-tree class="tree-editor" slot="sideContent" ref="jobGrpEditTree" :data="editTreeData" :props="defaultProps" node-key="treeKey" :expand-on-click-node="false"
        highlight-current draggable :allow-drag="allowDrag" :allow-drop="allowDrop" default-expand-all>
        <span class="el-tree-node__label" slot-scope="{ node, data }">
          <span v-if="node.level === 1">
            <span class="tree-node-edit-icon icon-margin-r" @click="appendJobGroup(node, data)">
              <i class="fas fa-plus-circle"></i>
            </span>
            <span>{{data.label}}</span>
          </span>
          <span v-else>
            <!-- <span class="tree-node-edit-icon mini" style="margin-right:-1px; margin-left: -1px" @click="appendJobGroup(node, data)">
              <i class="far fa-plus-circle"></i>
            </span> -->
            <span v-show="data.original.editableFlag === 'Y'" class="tree-node-edit-icon mini" @click="removeJobGroup(node, data)">
              <i class="far fa-minus-circle"></i>
            </span>
            <w-text-editor v-show="data.original.editableFlag === 'Y'" width="200px" :editing="editing" :target="node" property="label" ref="editor" @endEdit="onEndEdit" @click.native="editNode(data, node)">
              <span style="margin-left: 5px" class="tree-node-edit-label" slot="data">
                {{ node.label }}
              </span>
            </w-text-editor>
            <span v-show="data.original.editableFlag === 'N'" style="margin-left: 5px">
              {{ node.label }}
            </span>
          </span>
        </span>
      </el-tree>
    </div>
  </div>
</template>

<script>
import { cloneDeep, maxBy, has, forEach, isEmpty, isNil } from 'lodash';
import TreeFilter from '@/mixins/tree/filter';
import Editing from '@/mixins/editing';
import msgUtil from '@/utils/message';
import { defaultProps } from '@/constants/tree';

import amsSettingsApi from '@/api/settings/server/ams-settings';

import WTextEditor from './TextEditor';

export default {
  name: 'WJobGroupTreeView',
  mixins: [Editing, TreeFilter],
  components: { WTextEditor },
  data() {
    return {
      editMode: false,
      /**
       * 논리 그룹 트리 데이터
       * @type {Array}
       */
      jobGrpTreeData: [],
      /**
       * 선택한 논리 그룹 데이터 객체
       * @type {Object}
       */
      selectedGroupData: null,
      /**
       * 선택한 논리 그룹 노드 키
       * @type {String}
       */
      selectedGroupTreeKey: null,
      /**
       * 원본 트리 데이터
       * @type {Array}
       */
      originalTreeData: null,
      /**
       * 수정된 트리 데이터 (논리 그룹 트리 바인딩)
       * @type {Array}
       */
      editTreeData: [],
      /**
       * 기본 트리 props
       * @type {Object}
       */
      defaultProps,
      /**
       * 임시 트리 키 생성 인덱스
       * 편집 모드에서 추가 노드의 임시 키를 생성할 때 사용한다.
       * @type {Number}
       */
      tempIndex: 0,
      /**
       * 노드 라벨 편집 완료 전 변경된 임시 값 저장
       * @type {[type]}
       */
      editValue: null,
      /**
       * 삭제된 그룹 배열
       * @type {Array}
       */
      deleteGroups: [],
    };
  },
  watch: {
    /**
     * 논리 그룹 편집 제공 여부
     * true: 제공 → 데이터 로드
     * false: 숨김 → 데이터 초기화
     */
    editMode(to) {
      if (to === true) {
        this.loadEditTreeData();
      } else {
        this.resetData();
      }
    },
    jobGrpTreeData() {
      this.$nextTick(() => {
        const jobGrpTree = this.$refs.jobGrpTree;
        const root = jobGrpTree.root.childNodes[0];

        // if (!isEmpty(root.childNodes)) {
        //   const firstGroupNode = root.childNodes[0];
        //   const firstGroupTreeKey = firstGroupNode.data.treeKey;
        //   jobGrpTree.setCurrentKey(firstGroupTreeKey);
        //   this.selectedGroupTreeKey = firstGroupTreeKey;
        //   this.onCurrentGroupNodeChange(firstGroupNode.data, firstGroupNode);
        // }
        // TODO: 추후 root 선택 가능하게되면 위 코드는 삭제, 아래 코드 주석제거
        if (!isEmpty(root)) {
          const rootTreeKey = root.data.treeKey;
          jobGrpTree.setCurrentKey(rootTreeKey);
          this.selectedGroupTreeKey = rootTreeKey;
          this.onCurrentGroupNodeChange(root.data, root);
        }
      });
    },
  },
  methods: {
    /**
     * 작업 그룹 트리 데이터 로드
     * @author jeee12
     * @return {[type]} [description]
     */
    loadData() {
      amsSettingsApi.getAmsGrpTreeData({ grpType: 'JOB' }).then((response) => {
        if (response.data.success) {
          this.jobGrpTreeData = response.data.data;
        }
      });
    },
    /**
     * 화면의 데이터들을 로드한다.
     * @author Ju
     */
    loadEditTreeData() {
      this.originalTreeData = this.jobGrpTreeData;
      this.editTreeData = cloneDeep(this.jobGrpTreeData);
      this.loadData();
    },
    /**
     * 이전에 설정된 값들을 초기화한다.
     * @author Ju
     */
    resetData() {
      this.originalTreeData = [];
      this.editTreeData = [];
      this.tempIndex = 0;
      this.deleteGroups = [];
    },
    /**
     * 트리 편집모드 시작
     * @author jeee12
     * @return {[type]} [description]
     */
    startGroupTreeEditMode() {
      this.editMode = true;
    },
    /**
     * 작업 그룹 트리 노드 변경 이벤트 핸들러
     * @author Ju
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    onCurrentGroupNodeChange(data, node) {
      // if (node.level !== 1) {
      // root는 선택되지 않도록 함.
      // TODO: 추후 root 선택 가능하게되면 위 코드는 삭제
      this.selectedGroupData = data;
      this.insertObjList = [];
      this.deleteObjList = [];
      this.$emit('load-job-list', this.selectedGroupData);
      // }
    },
    /**
     * 작업 그룹 트리 노드 클릭 이벤트 핸들러
     * @author Ju
     * @param  {[type]} data    [description]
     * @param  {[type]} node    [description]
     * @param  {[type]} nodeCmp [description]
     * @return {[type]}         [description]
     */
    onGroupNodeClick(data, node, nodeCmp) {
      // if (node.level === 1) {
      //   // root 노드는 선택되지 않도로 막음.
      //   nodeCmp.$el.blur();
      //   const jobGrpTree = this.$refs.jobGrpTree;
      //   jobGrpTree.setCurrentNode(jobGrpTree.getNode(this.selectedGroupTreeKey));
      // } else {
      // TODO: 추후 root 선택 가능하게되면 위 코드는 삭제
      this.selectedGroupTreeKey = data.treeKey;
      // }
    },
    /**
     * 작업 그룹 트리 편집을 종료한다.
     * @author Ju
     * @return {[type]} [description]
     */
    endGroupTreeEditMode() {
      this.editMode = false;
      this.$emit('end-edit');
    },
    /**
     * 노드 drag 가능 여부 설정
     * @author Ju
     * @param  {Object} node 노드 객체
     */
    allowDrag(node) {
      // root node이거나 편집 중 일때는 drag를 못하게 한다. (+ 작업 그룹 - 기준정보인 데이터들은 노드 drag 불가)
      return this.editing.isEditing !== true && node.level !== 1 && node.data.original.editableFlag === 'Y';
    },
    /**
     * 노드 drop가능 여부 설정
     * @author Ju
     * @param  {Object} draggingNode 드래그된 노드 객체
     * @param  {Object} dropNode     드랍된 위치의 노드 객체
     * @param  {String} type         drop type: prev (이전) / next (이후) / inner (하위)
     */
    allowDrop(draggingNode, dropNode, type) {
      // drop node가 root node일 경우 하위 추가만 가능하도록 한다.
      // return type === 'inner' || dropNode.level !== 1;
      // drop 레벨1 - 하위로만 또는 drop 레벨2 - prev,next 만
      return (type === 'inner' && dropNode.level === 1) || (type !== 'inner' && dropNode.level === 2);
    },
    /**
     * 트리 노드 라벨 편집 완료 이벤트 핸들러
     * @author Ju
     * @param  {String} value    변경된 값
     * @param  {String} oldValue 이전 값
     */
    onEndEdit(value, oldValue) {
      // 공백이 입력될 경우 이전 값으로 설정하여 빈 값이 설정되지 않도록한다.
      if (isEmpty(value)) {
        this.endEdit(oldValue);
      } else {
        this.endEdit(value);
      }
      this.editValue = null;
    },
    /**
     * 트리 노드 라벨을 편집한다.
     * @param  {Object} data    클릭한 노드의 데이터
     * @param  {Object} node 클릭한 노드 객체
     */
    editNode(data, node) {
      this.startEdit(node, 'label', node.data);
    },
    /**
     * 선택한 노드의 하위에 새로운 작업 그룹을 추가한다.
     * @param {Object} data 선택한 노드의 데이터 객체
     */
    appendJobGroup(node, data) {
      if (node.expnaded !== true) {
        node.expanded = true;
      }

      if (isNil(data.children)) {
        this.$set(data, 'children', []);
      }

      // TODO: 작업그룹에 orderbyIndex 개념 추가시 주석 제거
      const lastChild = maxBy(data.children, (child) => child.original.orderbyIndex);
      let orderbyIndex = null;
      if (isEmpty(lastChild)) {
        orderbyIndex = 0;
      } else {
        orderbyIndex = lastChild.original.orderbyIndex + 1;
      }

      const jobGroup = {
        treeKey: `${data.treeKey}.temp_${this.tempIndex}`, // DB 반영 전이므로 임시 키를 적용한다.
        label: '새 작업그룹',
        children: [],
        phantom: true,
        original: {
          editableFlag: 'Y',
          visibleFlag: 'Y',
          grpType: 'JOB',
          orderbyIndex,
        },
        tempGrpId: `tmp_${this.tempIndex}`,
      };
      this.tempIndex += 1;
      data.children.push(jobGroup);

      this.$nextTick(() => {
        const newNode = this.$refs.jobGrpEditTree.getNode(jobGroup.treeKey);
        this.editNode(newNode.data, newNode);
      });
    },
    /**
     * 노드를 삭제한다.
     * @param  {object} node [노드 객체]
     * @param  {object} data [노드 데이터 객체]
     */
    removeJobGroup(node, data) {
      if (data.phantom !== true) {
        this.deleteGroups.push({
          grpId: data.grpId,
        });
      }

      this.addDeletedChildNodeIds(node);
      this.$refs.jobGrpEditTree.remove(data.treeKey);
    },
    /**
     * 삭제된 그룹 노드의 작업 그룹 아이디를 삭제 아이디 배열에 추가한다.
     * @author Ju
     * @param  {[type]} node [description]
     */
    addDeletedChildNodeIds(node) {
      if (!isEmpty(node.childNodes)) {
        forEach(node.childNodes, (childNode) => {
          if (childNode.data.phantom !== true) {
            this.deleteGroups.push({
              grpId: childNode.data.grpId,
            });
          }
          this.addDeletedChildNodeIds(childNode);
        });
      }
    },
    /**
     * 작업 그룹 트리 변경 내용을 저장한다.
     * @author Ju
     * @return {[type]} [description]
     */
    saveChangeGroupTree() {
      const modifiedData = {
        INSERT: [],
        UPDATE: [],
        orderbyIndex: 0,
      };
      const jobGrpEditTree = this.$refs.jobGrpEditTree;
      const root = jobGrpEditTree.getNode(jobGrpEditTree.root.data[0].treeKey);
      const childNodes = root.childNodes;
      if (!isEmpty(childNodes)) {
        const parent = {
          data: {
            grpId: 0,
          },
          childNodes,
        };
        this.setModifiedNodes(parent, modifiedData);
      }

      const params = {};
      if (!isEmpty(modifiedData.INSERT)) {
        params.INSERT = modifiedData.INSERT;
      }
      if (!isEmpty(modifiedData.UPDATE)) {
        params.UPDATE = modifiedData.UPDATE;
      }
      if (!isEmpty(this.deleteGroups)) {
        params.DELETE = this.deleteGroups;
      }

      const action = msgUtil.action.SAVE;
      const target = '작업 그룹 편집';

      // TODO: 저장/취소 버튼 변경이 있을 경우에만 활성화/비활성화 처리할 수 없는 화면이기 때문에
      // 일단 변경이 있어도 저장 성공으로 메시지 제공 후 화면 전환. 추후 uiux 가이드에 따라 수정 필요

      this.$confirm(...msgUtil.getBasicConfirmData(action)).then(() => {
        if (isEmpty(params)) {
          this.$message(msgUtil.getResultMsgData(action, target, true));
          this.endGroupTreeEditMode();
        } else {
          amsSettingsApi
            .updateAmsGrpTreeData(params)
            .then((res) => {
              if (!isEmpty(res.data) && res.data.success === true) {
                this.$message(msgUtil.getResultMsgData(action, target, true));
                this.deleteGroups = [];
                this.endGroupTreeEditMode();
                this.loadEditTreeData();
              } else {
                this.$message(msgUtil.getResultMsgData(action, target, false));
              }
            })
            .catch(() => {
              this.$message(msgUtil.getResultMsgData(action, target, false));
            });
        }
      });
    },
    /**
     * 추가/수정된 작업 그룹을 각각 추가/수정된 그룹 배열에 추가한다.
     * FK를 고려하여 parentGrpId의 그룹이 먼저 추가/수정되도록 상위 depth부터 각 depth별 노드를 확인하여 추가/수정된 노드를 추가하도록 함.
     * @author Ju
     * @param  {Object} nodeChildren 부모 노드의 아이디와 자식 노드 배열 객체
     * { parentGrpId: 'integer', children: [node object..] }
     */
    setModifiedNodes(parent, modifiedData) {
      const parentData = parent.data;
      const isPhantomParent = parentData.phantom ? parentData.phantom : false;
      const parentGrpId = isPhantomParent ? parentData.tempGrpId : parentData.grpId;
      const childNodes = parent.childNodes;

      forEach(childNodes, (child) => {
        modifiedData.orderbyIndex += 1;
        const data = child.data;
        if (data.phantom === true) {
          const addedData = {
            parentManagegroupId: 0,
            tempGrpId: data.tempGrpId,
            grpType: 'JOB',
            grpName: data.label,
            editableFlag: 'Y',
            visibleFlag: 'Y',
            // TODO: orderbyIndex 추가 후 코드 수정 필요 (서비스단 포함)
            orderbyIndex: modifiedData.orderbyIndex,
          };
          if (isPhantomParent) {
            addedData.tempParentGrpId = parentGrpId;
          } else {
            addedData.parentGrpId = parentGrpId;
          }

          modifiedData.INSERT.push(addedData);
        } else {
          const updatedData = {};
          // if ((!isNil(parentGrpId) || !isNil(data.original.parentGrpId)) && data.original.parentGrpId !== parentGrpId) {
          if ((!isNil(parentGrpId) && !isNil(data.original.parentGrpId)) && data.original.parentGrpId !== parentGrpId) {
            if (isPhantomParent) {
              updatedData.tempParentGrpId = parentGrpId;
            } else {
              updatedData.parentGrpId = parentGrpId;
            }
          }

          if (!isEmpty(data.modified) && has(data, 'modified.label')) {
            updatedData.grpName = data.label;
          }
          if (data.original.orderbyIndex !== modifiedData.orderbyIndex) {
            updatedData.orderbyIndex = modifiedData.orderbyIndex;
          }

          if (!isEmpty(updatedData)) {
            updatedData.grpId = data.grpId;

            if (!has(updatedData, 'parentGrpId') && !has(updatedData, 'tempParentGrpId')) {
              updatedData.parentGrpId = data.original.parentGrpId;
            }
            if (!has(updatedData, 'orderbyIndex')) {
              updatedData.orderbyIndex = data.original.orderbyIndex;
            }
            if (!has(updatedData, 'grpName')) {
              updatedData.grpName = data.original.grpName;
            }

            modifiedData.UPDATE.push(updatedData);
          }
        }

        this.setModifiedNodes(child, modifiedData);
      });
    },
    /**
     * 작업 그룹 트리 편집을 취소한다.
     * @author Ju
     */
    cancelChangeGroupTree() {
      this.endGroupTreeEditMode();
    },
    /**
     * 트리를 편집한다.
     * @return {[type]} [description]
     */
    edit() {
      this.editMode = true;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/server/AmsSettings/JobSetting/components/JobGroupTreeView.vue